/* width */
export const labtopL = '1440px';
export const desktop  = '1128px';
export const tablet  = '768px';
export const mobileLandscapeWidth = '520px';
